import angular from 'angular';

import RwLocationSelectorDialogComponent from './rw-location-selector-dialog-component';

export default angular
  .module('rw-location-selector-dialog', [
    'rw-button',
    'rw-subordinates-table',
  ])
  .component('rwLocationSelectorDialog', new RwLocationSelectorDialogComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-location-selector/components/rw-location-selector-dialog/rw-location-selector-dialog-module.js